import { Component } from '@angular/core';
import { IonSkeletonText, IonItem, IonTitle, IonRadio } from "@ionic/angular/standalone";

@Component({
    selector: 'radio-skeleton',
    templateUrl: './radio-skeleton.component.html',
    styleUrls: ['./radio-skeleton.component.scss'],
    imports: [IonItem, IonSkeletonText, IonTitle, IonRadio]
})
export class RadioSkeletonComponent{ }
